// Share.js

import { useState } from "react";

const Share = () => {
    const [dropDown, setDropDown] = useState(false);
    const url = window.location.href;

    const handleClick = () => {
        setDropDown(!dropDown);
    }

    // copyLink function
    const handleCopyLink = (event) => {
        event.preventDefault();
        navigator.clipboard.writeText(url)
        .then(() => {
            alert('Link copied successfully');
        })
        .catch((error) => {
            console.error('Failed to copy text: ', error);
        });

        setDropDown(false);
    }

    // share whatsapp function
    const handleShareClick = (event) => {
        const whatsAppShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        event.target.href = whatsAppShareUrl;
        setDropDown(false);
    }

    return (
        <div className="share">
            <div className="share-icon" onClick={handleClick}>
                <i className="fa-solid fa-arrow-up-from-bracket"></i>
            </div>

            <div className={`share-dropdown ${dropDown ? 'open' : ''}`}>
                <ul>
                    <li className="share-link">
                        <a href="/" onClick={handleCopyLink}>
                            <i className="fa-solid fa-link"></i>
                            <span>Copy link</span>
                        </a>
                    </li>

                    <li className="share-whatsapp">
                        <a href="/" target="_blank" rel="noopener noreferrer" onClick={handleShareClick}>
                            <i className="fab fa-whatsapp" aria-hidden="true"></i>
                            <span>WhatsApp</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Share;